<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-card>
                <b-row>
                    <b-col md="auto">
                        <div v-if="model.foto == null">No Photo</div>
                        <a v-else :href="$BASE_FILE_PATH + model.foto" target="_blank">
                            <img :src="$BASE_FILE_PATH + model.foto" style="max-height: 100px" />
                        </a>
                    </b-col>
                    <b-col>
                        <h3>{{ model.name }}</h3>
                        <hr />
                        <div><b>{{ model.kategori.name }}</b></div>
                        <div>Rp. {{ $helper.formatThousandSeparator(model.minHarga) }} - Rp. {{ $helper.formatThousandSeparator(model.maxHarga) }}</div>
                    </b-col>
                </b-row>
            </b-card>
            <b-card no-body>
                <b-tabs card pills vertical lazy>
                    <b-tab title="Ukuran Baru" active>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Nama">
                                    <b-form-input v-model="input.name" maxlength="10" />
                                </b-form-group>
                                <b-form-group label="Harga">
                                    <b-form-input v-model="input.harga" maxlength="20" />
                                </b-form-group>
                                <b-btn variant="primary" :disabled="isSubmitting" @click="executeInput">
                                    <b-spinner small type="grow" v-if="isSubmitting" />
                                    {{ isSubmitting ? 'Menyimpan...' : 'Simpan' }}
                                </b-btn>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab v-for="item in ukuran" v-bind:key="item.id" :title="item.name">
                        <Ukuran :id="item.id" @on-edit-ukuran="onEditUkuran" />
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import Ukuran from './Ukuran'

export default {
    name: "model-detail",
    components: {
        Ukuran
    },
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            input: {
                name: "",
                harga: ""
            },

            model: {},
            ukuran: [],

        }
    },
    methods: {

        init() {

            this.initStatus = 0

            let getModelDetail = this.$axios.get("model/" + this.$route.params.id).then(res => {
                this.model = res.data
            })

            let getUkuran = this.$axios.get("ukuran/?modelId=" + this.$route.params.id).then(res => {
                this.ukuran = res.data
                this.ukuran.sort((a, b) => a.harga - b.harga)
            })

            Promise.all([getModelDetail, getUkuran]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        executeInput() {

            if(this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.$helper.isBlank(this.input.harga)) {
                return this.$helper.toastError(this, "Harga tidak boleh kosong!")
            }

            let harga = this.input.harga.replace(/\./g, "")

            let payload = new FormData()
            payload.append("name", this.input.name)
            payload.append("harga", harga)
            payload.append("modelId", this.$route.params.id)

            this.isSubmitting = true
            this.$axios.post("ukuran/", payload).then(res => {

                this.ukuran.push(res.data)
                this.input.name = ""
                this.input.harga = ""

                this.refreshMinMaxHarga()
                this.$helper.toastSuccess(this, "Ukuran baru berhasil ditambahkan!")

            })
            .catch(error => { this.$helper.parseError(this, error) })
            .finally(() => { this.isSubmitting = false })

        },

        onEditUkuran(data) {

            let item = this.ukuran.find(it => it.id == data.id)
            item.name = data.name
            item.harga = data.harga
            this.refreshMinMaxHarga(data.harga)

        },

        refreshMinMaxHarga() {

            let harga = this.ukuran.map(it => it.harga)

            this.model.minHarga = Math.min.apply(Math, harga)
            this.model.maxHarga = Math.max.apply(Math, harga)

            this.ukuran.sort((a, b) => a.harga - b.harga)

        }

    },
    watch: {

        "input.harga": function(newValue) {

            const result = newValue.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            this.$nextTick(() => this.input.harga = result)

        }

    },
    created() {
        this.init()
    }
}
</script>
